const _toRad = (deg: number) => deg * (Math.PI / 180.0);

export class BlobGenerator {

  static create(color: string, size = 400, outerGrowth: number = 1.0, innerGrowth: number = .5, edges: number = 6, seed: number = null): string {
    return `<path d="${this.createSvgPath(this.createPoints(size, outerGrowth, innerGrowth, edges, seed))}" fill="${color}" />`;
  }

  private static divide(count: number): number[] {
    const deg = 360 / count;
    return Array(count)
      .fill("")
      .map((_, i) => i * deg);
  }

  private static randomDoubleGenerator(s: number): () => number {
    const mask = 0xffffffff;
    let m_w = (123456789 + s) & mask;
    let m_z = (987654321 - s) & mask;

    return function () {
      m_z = (36969 * (m_z & 65535) + (m_z >>> 16)) & mask;
      m_w = (18000 * (m_w & 65535) + (m_w >>> 16)) & mask;

      return (((m_z << 16) + (m_w & 65535)) >>> 0) / 4294967296;
    };
  }

  private static magicPoint(value: number, min: number, max: number): number {
    let radius = min + value * (max - min);
    if (radius > max) {
      radius = radius - min;
    } else if (radius < min) {
      radius = radius + min;
    }
    return radius;
  }

  private static point(origin, radius, degree): number[] {
    const x = origin + radius * Math.cos(_toRad(degree));
    const y = origin + radius * Math.sin(_toRad(degree)) + radius * 0.2;
    return [Math.round(x), Math.round(y)];
  }

  private static createPoints(size: number, outerGrowth: number, innerGrowth: number, edgesCount: number, seed: number): number[] {
    let outerRad = outerGrowth * (size / 2);
    let innerRad = innerGrowth * (size / 2);
    let center = size / 2;

    let slices = this.divide(edgesCount);
    let id = Math.floor(Math.random() * 1000000);
    let seedValue = seed || id;
    let randVal = this.randomDoubleGenerator(seedValue);
    let destPoints = [];

    slices.forEach((degree) => {
      let O = this.magicPoint(randVal(), innerRad, outerRad);
      let end = this.point(center, O, degree);
      destPoints.push(end);
    });
    return destPoints;
  };

  private static createSvgPath(points: number[]): string {
    let svgPath = "";
    let mid = [
      (points[0][0] + points[1][0]) / 2,
      (points[0][1] + points[1][1]) / 2,
    ];
    svgPath += "M" + mid[0] + "," + mid[1];

    for (let i = 0; i < points.length; i++) {
      const p1 = points[(i + 1) % points.length];
      const p2 = points[(i + 2) % points.length];
      mid = [(p1[0] + p2[0]) / 2, (p1[1] + p2[1]) / 2];
      svgPath += "Q" + p1[0] + "," + p1[1] + "," + mid[0] + "," + mid[1];
    }
    svgPath += "Z";
    return svgPath;
  };
}